import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

interface ErrorTextProps {
  error?: string;
}

export default function ErrorText({ error }: ErrorTextProps) {
  if (!error) return null;

  return (
    <View style={styles.container}>
      <Ionicons name="alert-circle" size={14} color="#D32F2F" />
      <Text style={styles.errorText}>{error}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 4,
    marginBottom: 8,
    paddingHorizontal: 4,
  },
  errorText: {
    fontFamily: 'Inter_400Regular',
    fontSize: 12,
    color: '#D32F2F',
    marginLeft: 4,
    flex: 1,
  },
});
